import { CoinSide } from '@/models/bet/coinflip/side';
import { m } from 'framer-motion';
import { useMemo } from 'react';
import CoinflipBoardResultCoin from './Coin';
import { CoinflipBoardResultProps } from './props';
import styles from './styles.module.scss';
import { wrapperVariants } from './variants';

export default function CoinflipBoardResult({
  isLoading,
  sides,
  secondary,
}: CoinflipBoardResultProps) {
  const Coins = useMemo(
    () =>
      sides?.map((side: CoinSide, index) => (
        <CoinflipBoardResultCoin side={side} key={`coinflip_result_${index}`} />
      )),
    [sides],
  );
  const Skeletons = useMemo(
    () =>
      Array.from({ length: 3 }).map((_, index) => (
        <CoinflipBoardResultCoin
          key={`coinflip_result_skeleton_${index}`}
          isLoading
        />
      )),
    [],
  );

  return (
    <m.div
      className={`${styles.container} ${sides?.length > 0 || isLoading ? styles['container--visible'] : ''} ${secondary ? styles['container--secondary'] : ''}`}
      variants={wrapperVariants}
      initial="closed"
      animate="open"
      exit="closed"
    >
      {isLoading ? Skeletons : Coins}
    </m.div>
  );
}
